import { combineReducers } from 'redux';

import { ActionType } from 'store/ActionType';
import { ConsentUpdateQumuActionType } from 'store/Consent/consentAction';

const qumu = (state = false, action: ActionType) => {
    if (action.type === ConsentUpdateQumuActionType) {
        return action.payload;
    }
    return state;
};

export default combineReducers({
    qumu,
});
